import React, { useState, useEffect } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

/**
 * Premium Snowflake Effect using a high-fidelity crystalline sprite.
 * Optimized for performance and site-wide visibility.
 */
const SnowEffect = () => {
    const [init, setInit] = useState(false);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    if (!init) return null;

    return (
        <Particles
            id="tsparticles"
            options={{
                fullScreen: {
                    enable: true,
                    zIndex: 9999
                },
                fpsLimit: 120,
                particles: {
                    number: {
                        value: 50,
                        density: { enable: true, area: 800 },
                    },
                    color: { value: "#ffffff" },
                    shape: {
                        type: "image",
                        options: {
                            image: {
                                src: "/assets/snowflake2.png",
                                width: 129,
                                height: 141
                            }
                        }
                    },
                    opacity: {
                        value: { min: 0.4, max: 0.9 },
                        animation: {
                            enable: true,
                            speed: 0.5,
                            sync: false,
                        },
                    },
                    size: {
                        value: { min: 8, max: 20 }, // Larger for beautiful crystalline details
                    },
                    move: {
                        enable: true,
                        speed: { min: 1.5, max: 3 },
                        direction: "bottom",
                        random: false,
                        straight: false,
                        outModes: { default: "out" },
                    },
                    rotate: {
                        value: { min: 0, max: 360 },
                        animation: {
                            enable: true,
                            speed: 5,
                        },
                    },
                    wobble: {
                        enable: true,
                        distance: 10,
                        speed: 10,
                    },
                },
                detectRetina: true,
            }}
        />
    );
};

export default SnowEffect;
